module.exports = __webpack_public_path__ + "static/media/mobile-menu-icon-white.48e1c7c5.svg";